/*
 * EnviAir — Product compare
 *
 * Selection only. Checked products are kept in localStorage and a floating
 * button appears while at least one is selected; it links to the compare page
 * with the chosen handles passed as a query string.
 *
 * The compare page itself is intentionally not built yet — when it is, it
 * should read the `products` query parameter this sends rather than reaching
 * into localStorage.
 */
(function () {
  var STORAGE_KEY = 'enviair:compare';
  var MAX = 4;

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      // Private mode, or a stale value from an older format.
      return [];
    }
  }

  function write(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* Selection still works for this page view. */
    }
  }

  var items = read();

  function indexOfHandle(handle) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === handle) return i;
    }
    return -1;
  }

  // --- Floating button ----------------------------------------------------

  var bar = null;

  function ensureBar() {
    if (bar) return bar;
    bar = document.createElement('a');
    bar.className = 'ea-compare-bar';
    bar.setAttribute('hidden', '');
    document.body.appendChild(bar);
    return bar;
  }

  function comparePath() {
    var el = document.querySelector('[data-ea-compare-url]');
    return (el && el.getAttribute('data-ea-compare-url')) || '/pages/compare';
  }

  function render() {
    var el = ensureBar();

    if (items.length === 0) {
      el.setAttribute('hidden', '');
      return;
    }

    var handles = items
      .map(function (item) {
        return item.handle;
      })
      .filter(Boolean);

    el.href = comparePath() + '?products=' + encodeURIComponent(handles.join(','));
    el.innerHTML =
      '<span class="ea-compare-bar__label">Compare</span>' +
      '<span class="ea-compare-bar__count">' + items.length + '</span>';
    el.removeAttribute('hidden');
  }

  // --- Checkboxes ---------------------------------------------------------

  function syncInputs(scope) {
    (scope || document).querySelectorAll('[data-ea-compare]').forEach(function (input) {
      input.checked = indexOfHandle(input.dataset.productHandle) !== -1;
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-ea-compare]');
    if (!input) return;

    var handle = input.dataset.productHandle;
    var at = indexOfHandle(handle);

    if (input.checked && at === -1) {
      if (items.length >= MAX) {
        input.checked = false;
        window.alert('You can compare up to ' + MAX + ' products at a time.');
        return;
      }
      items.push({ id: input.dataset.productId, handle: handle });
    } else if (!input.checked && at !== -1) {
      items.splice(at, 1);
    }

    write(items);
    render();
  });

  // Another tab changed the selection.
  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY) return;
    items = read();
    syncInputs();
    render();
  });

  function init() {
    syncInputs();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Filtering and pagination replace the grid, so restore checked state.
  document.addEventListener('shopify:section:load', function (event) {
    syncInputs(event.target);
  });

  new MutationObserver(function () {
    syncInputs();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
